import models from './models'
import menu from './menu'
import routes from './routes'

export default {

  name: 'Products',

  setup () {
    return {
      menu,
      routes
    }
  },

  models () {
    return {
      'product': models.Product,
      'product:variants': models.VariantOption,
      'product:image': models.Image,
      'taxonomy': models.Taxonomy
    }
  }

}
